<app-breadcrumb [title]="'Online Course'" [items]="['Dashboard']" [active_item]="'Online Course'"></app-breadcrumb>
<div class="container-fluid">
   <div class="row">
     <div class="col-xxl-5 col-ed-6 col-xl-8 box-col-7">
       <app-hello-name></app-hello-name>
     </div>
     <div class="col-xxl-2 col-ed-3 col-xl-4 col-sm-6 box-col-5">
       <app-today-progress></app-today-progress>
     </div>
     <div class="col-xl-2 col-ed-3 d-xxl-block d-sm-none box-col-none">
       <app-more-details></app-more-details>
     </div>
     <div class="col-xxl-3 col-ed-5 col-xl-5 col-sm-6 box-col-5">
       <app-calendar></app-calendar>
     </div>
     <div class="col-xxl-5 col-ed-7 col-xl-7 box-col-7">
       <app-learning-overview></app-learning-overview>
     </div>
     <div class="col-xxl-4 col-ed-7 col-xl-7 col-md-6 box-col-7"> 
       <app-activity-hours></app-activity-hours>
     </div>
     <div class="col-xxl-3 col-ed-5 col-xl-5 col-md-6 box-col-5">
       <app-upcoming-events></app-upcoming-events>
     </div>
     <div class="col-xxl-5 col-ed-12 box-col-12"> 
       <app-my-course></app-my-course>
     </div>
     <div class="col-xxl-4 col-ed-6 col-md-7 box-col-7">
       <app-upcoming-schedule></app-upcoming-schedule>
     </div>
     <div class="col-xxl-3 col-ed-6 col-md-5 col-sm-6 box-col-5">
       <app-active-lessons></app-active-lessons>
     </div>
   </div>
 </div>